import React from 'react';
import { Link } from 'react-router-dom';
import { getApplicationNumberSearchLines } from '../../utils/applicationDisplayFormat';

/** Минимальные поля заявки для отображения № и даты (основной поток, карточки, workspace). */
export type ApplicationCellApplication = {
  id?: number;
  applicationId?: number;
  internalNumber?: string | null;
  number?: string | null;
  /** альтернативное имя номера (партнёрские и пр.) */
  applicationNumber?: string | null;
  applicationDate?: string | null;
};

function resolveId(a: ApplicationCellApplication): number | null {
  if (a.id != null) return a.id;
  if (a.applicationId != null) return a.applicationId;
  return null;
}

function toFormatFields(a: ApplicationCellApplication) {
  const n =
    (a.internalNumber && String(a.internalNumber).trim()) ||
    (a.number && String(a.number).trim()) ||
    (a.applicationNumber && String(a.applicationNumber).trim()) ||
    (resolveId(a) != null ? String(resolveId(a)) : '');
  return { internalNumber: n, applicationDate: a.applicationDate ?? null };
}

export type ApplicationCellProps = {
  application: ApplicationCellApplication;
  /**
   * Показать ссылку на `/applications/:id`.
   * По умолчанию: true, если известен id (id или applicationId).
   * Для сущностей, где id — не id заявки (например partner-applications), передать `false`.
   */
  withLink?: boolean;
  /**
   * Блок в Descriptions карточки заявки: номер и дата одного размера, без серой мелкой второй строки.
   */
  forDescriptionCard?: boolean;
};

/**
 * Две строки: № внутреннего номера (ссылка) и дата заявки.
 * В таблицах вторая строка — secondary-text; в карточке — равный кегль (forDescriptionCard).
 * Клик по ссылке: stopPropagation (для таблиц с onRow).
 */
export const ApplicationCell: React.FC<ApplicationCellProps> = ({ application, withLink, forDescriptionCard }) => {
  const id = resolveId(application);
  const fields = toFormatFields(application);
  const { line1, line2 } = getApplicationNumberSearchLines(fields);
  const showLink = withLink !== false && id != null;

  const firstLine = showLink ? (
    <Link to={`/applications/${id}`} onClick={(e) => e.stopPropagation()}>
      {line1}
    </Link>
  ) : (
    <span>{line1}</span>
  );

  if (forDescriptionCard) {
    return (
      <div className="application-card-id-block">
        <div className="application-card-id-block__line1">{firstLine}</div>
        <div className="application-card-id-block__line2">{line2}</div>
      </div>
    );
  }

  return (
    <>
      <div className="primary-cell">{firstLine}</div>
      <div className="secondary-text">{line2}</div>
    </>
  );
};

export default ApplicationCell;
